<div>
    <app-designation-form></app-designation-form>
</div>
<div>
    <app-designation-list></app-designation-list>
</div>